
export default function ModaConscienteSection() {
  return (
    <section className="py-20 bg-amber-50/60">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-white rounded-3xl border border-stone-200 shadow-sm overflow-hidden">
          {/* Decoración lateral */}
          <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-emerald-600 via-emerald-500 to-amber-500"></div>

          <div className="px-8 sm:px-12 py-12 sm:py-14">
            <div className="flex flex-col md:flex-row items-start gap-8">
              {/* Icono */}
              <div className="shrink-0">
                <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-2xl">
                  <i className="ri-leaf-line text-emerald-700 text-3xl"></i>
                </div>
              </div>

              {/* Contenido */}
              <div className="space-y-5">
                <h2 className="text-3xl sm:text-4xl font-bold text-stone-800 font-serif leading-tight">
                  Moda consciente en la Patagonia
                </h2>
                <p className="text-lg text-stone-600 leading-relaxed max-w-3xl">
                  La ropa usada es el futuro. Ya existe suficiente en el mundo para muchas generaciones más. 
                  Aquí puedes encontrar piezas únicas, marcas a precios accesibles y consumir de manera más 
                  consciente, ahorrando sin perder estilo.
                </p>
                <div className="flex flex-wrap gap-3 pt-2">
                  <span className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-800 px-4 py-2 rounded-full text-sm font-medium">
                    <i className="ri-recycle-line text-base"></i>
                    Consumo responsable
                  </span>
                  <span className="inline-flex items-center gap-2 bg-amber-50 text-amber-800 px-4 py-2 rounded-full text-sm font-medium">
                    <i className="ri-price-tag-3-line text-base"></i>
                    Precios accesibles
                  </span>
                  <span className="inline-flex items-center gap-2 bg-stone-100 text-stone-700 px-4 py-2 rounded-full text-sm font-medium">
                    <i className="ri-star-line text-base"></i>
                    Piezas únicas
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
